import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="app-footer">
      <small>
        {t('footer-copyright')} •{' '}
        <a href="/privacy-policy" target="_blank" rel="noopener">
          {t('privacy-title')}
        </a>
      </small>
    </footer>
  );
};

export default React.memo(Footer);
